import { UrlParamVo } from 'bl-od/lib/vos/url/url-param-vo';

export class RouteVariable {
  private readonly _prefix  : string | undefined;
  private readonly _urlParam: UrlParamVo | undefined;

  constructor(prefix: string | undefined,urlParam?: UrlParamVo|undefined ) {
    this._prefix = prefix;
    this._urlParam = urlParam;
  }

  public get fullPrefix(): string | undefined {
    return this._prefix ==null?undefined:`${this._prefix}-:`;
  }

  public get prefix(): string | undefined {
    return this._prefix;
  }

  public get urlParam(): UrlParamVo | undefined {
    return this._urlParam;
  }

  public get path(): string  {
    if(this._urlParam==null){
    return  (this._prefix==null)?``:this._prefix;
    }
    return ((this._prefix==null)?``:`${this._prefix}-`)+`:${this._urlParam}`;
  }
}

export const routeVariables = {
  DESK: new RouteVariable(`d`,UrlParamVo.DESK),
  LNG: new RouteVariable(undefined,UrlParamVo.LNG),
  URI: new RouteVariable(`o`,UrlParamVo.URI),
  APP_ID: new RouteVariable(undefined,UrlParamVo.APP_ID),
  ID: new RouteVariable(undefined,UrlParamVo.ID),
  WORK_ITEM_APP_ID: new RouteVariable(undefined,UrlParamVo.WORK_ITEM_APP_ID),
  FEATURES: new RouteVariable(`features`),
  FEATURE: new RouteVariable(`feature`),
  TICKETS: new RouteVariable(`tickets`),
  TICKET: new RouteVariable(`ticket`),
  TASKS: new RouteVariable(`tasks`),
  TASK: new RouteVariable(`task`),
  WI_CS4: new RouteVariable(`wi-cs4`),
  WI_C4: new RouteVariable(`wi-c4`),
  WI_CS5: new RouteVariable(`wi-cs5`),
  WI_C5: new RouteVariable(`wi-c5`),
  MESSENGER: new RouteVariable(`messenger`),
  CONVERSATION: new RouteVariable(`conversation`),
  WEB_FORM: new RouteVariable(`web-form`),
  WEB_FORMS: new RouteVariable(`web-forms`),
  WORK_ITEM_APP: new RouteVariable(`workItemApp`),
  WORK_ITEM: new RouteVariable(`workItem`,UrlParamVo.WORK_ITEM_ID),
  WEB_PAGE: new RouteVariable(`web-page`),
  MORE: new RouteVariable(`more`),
  KNOWLEDGE_BASE: new RouteVariable(`knowledge-base`),
  CATEGORY: new RouteVariable(`category`),
  SUB_CATEGORY: new RouteVariable(`sub-category`),
  ARTICLE_NAME: new RouteVariable(`article`,UrlParamVo.ARTICLE_NAME),
  ARTICLE: new RouteVariable(`article`),
  CHOOSE_DESK: new RouteVariable(`choose-desk`),
  CHOOSE_ORGANIZATION: new RouteVariable(`choose-organization`),
  APP_NAME: new RouteVariable(undefined, UrlParamVo.APP_NAME),
  SEARCH_ALL: new RouteVariable(`search-all`),
  SETTING: new RouteVariable(`setting`),
  SETTING_PROFILE: new RouteVariable(`setting-profile`),
  SETTING_NOTIFICATIONS: new RouteVariable(`setting-notifications`),
  SETTING_APPEARANCE: new RouteVariable(`setting-appearance`),
  SIGN_IN: new RouteVariable(`sign-in`),
  SIGN_UP: new RouteVariable(`sign-up`),
  RESET_PASSWORD: new RouteVariable(`reset-password`),
  PAGE_NOT_FOUND: new RouteVariable(`page-not-found`),
  UNIVERSAL_LINK: new RouteVariable(`universal-link`),
  NOTIFICATIONS: new RouteVariable(`notifications`),
  APPEARANCE: new RouteVariable(`appearance`),
  PROFILE: new RouteVariable(`profile`),
  REGISTER: new RouteVariable(`register`),
  TIMESHEETS: new RouteVariable(`timesheets`),
  TIMESHEET: new RouteVariable(`timesheet`),
  TIMER: new RouteVariable(`timer`),
  NO_APPLICATIONS: new RouteVariable(`no-applications`)
};
